import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const TOKEN_KEY = "indushub_token";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const downloadInvoice = async (id, ref, lang) => {
  const { data } = await api.get(`/interventions/${id}/invoice`, { params: { lang }, responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${ref}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const fileUrl = (path) => (path ? `${process.env.REACT_APP_BACKEND_URL}${path}` : null);

export const fmtDuration = (sec) => {
  const s = Math.max(0, Math.floor(sec));
  const p = (n) => String(n).padStart(2, "0");
  return `${p(Math.floor(s / 3600))}:${p(Math.floor((s % 3600) / 60))}:${p(s % 60)}`;
};

export const fmtEur = (n, lang) =>
  new Intl.NumberFormat(lang === "en" ? "en-GB" : "fr-FR", { style: "currency", currency: "EUR" }).format(n || 0);

export const fmtDate = (iso, lang) =>
  new Date(iso).toLocaleDateString(lang === "en" ? "en-GB" : "fr-FR", { day: "2-digit", month: "short", year: "numeric" });

export const apiErrorField = (err) => {
  const detail = err?.response?.data?.detail;
  if (!Array.isArray(detail)) return {};
  return detail.reduce((acc, d) => {
    const field = d?.loc?.[d.loc.length - 1];
    if (typeof field === "string") acc[field] = "generic";
    return acc;
  }, {});
};

export const downloadFile = async (path, fallbackName) => {
  const res = await api.get(path, { responseType: "blob" });
  const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || fallbackName;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
